import React from 'react';

import PropTypes from 'prop-types';

import { Mui } from 'components';

function GroupByFilter({ value, onChange, size = 'small' }) {
  return (
    <Mui.FormControl variant="outlined" fullWidth margin="none" size={size}>
      <Mui.InputLabel id="groupByLabel">Agrupado por</Mui.InputLabel>
      <Mui.Select
        fullWidth
        label="Agrupado por"
        labelId="groupByLabel"
        value={value || 'month'}
        onChange={event => onChange(event.target.value)}
        variant="outlined">
        <Mui.MenuItem value="month">Mês</Mui.MenuItem>
        <Mui.MenuItem value="day">Dia</Mui.MenuItem>
      </Mui.Select>
    </Mui.FormControl>
  );
}

GroupByFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
};

export default GroupByFilter;
